export default __webpack_public_path__ + "static/media/asters-pause-video.c00cd1a2.svg";